<template>
  <section class="p-2">
    <v-card flat>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Security</div>
        <div>
          <bread-crumb :bread-crumbs="['Security']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-col cols="12" md="3" lg="3" sm="12">
        <v-card class="ma-2">
          <v-card-title class="text-h6 lighten-2 justify-center p-0 m-0">
            <v-icon class="me-2">mdi-shield-account</v-icon>2FA
          </v-card-title>
          <v-divider class="m-0 p-0"></v-divider>
          <v-card-text class="p-0">
            <v-row class="d-flex justify-space-around" no-gutters>
              <v-col cols="9" md="9" class="">
                <v-subheader class="font-weight-bold labelFontsize"
                  >Admin
                </v-subheader></v-col
              >
              <v-col cols="2" class="d-flex justify-center">
                <v-switch
                  color="green"
                  class="mt-1"
                  v-model="admin"
                  dense
                  @change="TwoFactorAuth('USR', admin)"
                >
                </v-switch>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-space-around" no-gutters>
              <v-col cols="9">
                <v-subheader class="font-weight-bold labelFontsize"
                  >Compliance
                </v-subheader></v-col
              >
              <v-col cols="2" class="d-flex justify-center">
                <v-switch
                  color="green"
                  v-model="complaince"
                  @click="TwoFactorAuth('complaince', complaince)"
                ></v-switch
              ></v-col>
            </v-row>
            <v-row class="d-flex justify-space-around" no-gutters>
              <v-col cols="9">
                <v-subheader class="font-weight-bold labelFontsize"
                  >Sales
                </v-subheader></v-col
              >
              <v-col cols="2" class="d-flex justify-center">
                <v-switch
                  color="green"
                  v-model="sales"
                  dense
                  @click="TwoFactorAuth('Sales', sales)"
                ></v-switch
              ></v-col>
            </v-row>
            <v-row class="d-flex justify-space-around labelFontsize" no-gutters>
              <v-col cols="9">
                <v-subheader class="font-weight-bold labelFontsize"
                  >Treasury
                </v-subheader></v-col
              >
              <v-col cols="2" class="d-flex justify-center">
                <v-switch
                  color="green"
                  v-model="treasury"
                  @click="TwoFactorAuth('Treasury', treasury)"
                ></v-switch
              ></v-col>
            </v-row>

            <v-row class="d-flex justify-space-around labelFontsize" no-gutters>
              <v-col cols="9">
                <v-subheader class="font-weight-bold labelFontsize"
                  >Finance
                </v-subheader></v-col
              >
              <v-col cols="2" class="d-flex justify-center">
                <v-switch
                  color="green"
                  v-model="finance"
                  @click="TwoFactorAuth('Finance', finance)"
                ></v-switch
              ></v-col>
            </v-row>
            <v-row class="d-flex justify-space-around" no-gutters>
              <v-col cols="9">
                <v-subheader class="font-weight-bold labelFontsize"
                  >Evolet
                </v-subheader></v-col
              >
              <v-col cols="2" class="d-flex justify-center">
                <v-switch
                  color="green"
                  v-model="evolet"
                  @click="TwoFactorAuth('PRT', evolet)"
                ></v-switch
              ></v-col>
            </v-row>
            <OverlayPageVue :showOverlay="loaderOverlay" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import userService from "@/services/UserService/userService.js";
import alerts from "@/mixins/alerts";
export default {
  name: "Security",
  mixins: [alerts],
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  data() {
    return {
      valid: true,
      admin: null,
      sales: null,
      complaince: null,
      finance: null,
      treasury: null,
      evolet: null,
      loaderOverlay: false,
    };
  },
  watch: {},
  mounted() {
    this.get2TFAvalue();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async get2TFAvalue() {
      this.loaderOverlay = true;
      try {
        const response = await userService.get2FAstatus();
        if (response.data.status_code === 200) {
          this.stoploader();
          const status = response.data.data[0];
          this.admin = status.admin;
          this.sales = status.sales;
          this.treasury = status.treasury;
          this.complaince = status.complaince;
          this.finance = status.finance;
          this.evolet = status.evolet;
          console.log("status", response.data.data[0]);
          return response.data?.data;
        } 
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.get2TFAvalue();
        //   this.stoploader();
        // }
      } catch (error) {
        this.stoploader();
        console.error(error);
      }
    },
    async TwoFactorAuth(val, status_val) {
      this.loaderOverlay = true;
      try {
        const responseData = await userService.updateTwoFactorAuth(
          val,
          status_val
        );
        if (responseData && responseData.data.status_code == 200) {
          this.stoploader();
          this.showAlertSuccess(responseData.data.message);
          this.get2TFAvalue();
        } 
        // else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.TwoFactorAuth(val, status_val);
        //   this.stoploader();
        // } 
        else {
          this.showAlertError("Something went wrong please try again later.");
          this.stoploader();
        }
      } catch (error) {
        console.log(error.response);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.green {
  color: red !important;
}
.v-messages {
  min-height: 0px !important;
}
/* .v-subheader{
    padding: 0px !important;
  } */
</style>
